import { Button, ButtonProps } from '@mui/material'
import React from 'react'

interface OutlinedButtonProps extends ButtonProps {
  customText?: string
}

export const OutlinedButton: React.FC<OutlinedButtonProps> = ({ children, ...props }) => {

  const { customText, sx, ...rest } = props

  return (
    <Button
      {...rest}
      variant="outlined"
      sx={{
        borderRadius: 2,
        textTransform: 'none',
       
        ...sx,
      }}
    >
      {children}
    </Button>
  )
}
